import {TBadgeColor} from 'src/components';
import {TSubject} from 'src/constants';
import {EResellerIds} from 'src/containers/User';

export enum EStatus {
  DRAFT = 'DRAFT',
  LOGIN_REQUIRED = 'LOGIN_REQUIRED',
  CANCELLED = 'CANCELLED',
  DONE = 'DONE',
  LOGGED_OUT = 'LOGGED_OUT',
  // frontend status
  IN_PROGRESS = 'IN_PROGRESS',
}

export enum EFormSteps {
  SETTINGS = 'SETTINGS',
  QR = 'QR',
}

export type TTelegramChannel = {
  id: number;
  status: EStatus;
  name: string;
  availableTariffId?: number;
  qrLink?: string;
  subjectRef?: TSubject;
  // for tech partner channel
  code?: string;
  clientProfileId?: number;
};

export type TFormData = Partial<TTelegramChannel>;

export const statusColorHash: Record<keyof typeof EStatus, TBadgeColor> = {
  DRAFT: 'BLUE',
  LOGIN_REQUIRED: 'PURPLE',
  IN_PROGRESS: 'YELLOW',
  LOGGED_OUT: 'PURPLE',
  CANCELLED: 'GREY',
  DONE: 'GREEN',
};

export const NAME_MAX_LENGTH = 512;

export enum ETechPartnerStatus {
  NEW = 'NEW',
  ACCEPTED = 'ACCEPTED',
  DELETED = 'DELETED',
}

export type TTechPartnerChannel = {
  id: number;
  name: string;
  availableTariffId?: number;
  code: string;
  status: ETechPartnerStatus;
};

export const techPartnerStatusColorHash: Record<keyof typeof ETechPartnerStatus, TBadgeColor> = {
  NEW: 'BLUE',
  ACCEPTED: 'GREEN',
  DELETED: 'GREY',
};

export type TPublicChannel = {
  id: number;
  partnerName: string;
  status: ETechPartnerStatus;
  resellerId: EResellerIds;
  code: string;
  availableTariffId: number;
  createdAt?: string;
  updatedAt?: string;
  qrLink: string;
};
